import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface DashboardPatient {
  patient_id: number;
  user_name?: string;
  turnaround_time?: string;
  organization?: string;
  super_org?: string;
  specialty?: string;
  patient_specialty?: string | null;
  appt_time?: string;
  [key: string]: unknown;
}

export const dashboardSummaryKeys = {
  all: ["dashboardSummary"] as const,
  byDate: (pickedDate: string) => [...dashboardSummaryKeys.all, pickedDate] as const,
};

interface UseDashboardSummaryOptions {
  pickedDate: string;
  enabled?: boolean;
  refetchInterval?: number | false;
}

export function useDashboardSummary({
  pickedDate,
  enabled = true,
  refetchInterval = 5000,
}: UseDashboardSummaryOptions) {
  return useQuery({
    queryKey: dashboardSummaryKeys.byDate(pickedDate),
    queryFn: async () => {
      const response = await api.get<DashboardPatient[]>("/dashboard/summary", {
        headers: { pickedDate },
      });
      return response;
    },
    enabled,
    staleTime: 0,
    refetchInterval,
    // Hidden/background tabs should not keep hitting /dashboard/summary; a VA
    // provider often has several tabs open, which multiplied the poll rate and
    // the pool's connection demand for no visible benefit.
    refetchIntervalInBackground: false,
  });
}

export default useDashboardSummary;
